import { fork, put, takeEvery } from "redux-saga/effects";

import { callApi } from "sagas/helpers/api";
import { setError, setSuccess, startLoading } from "store/appSlice";

import * as CashProvidersApi from "../api/Providers";
import {
  fetchSupportedCurrencies,
  setSupportedCurrencies,
} from "./providers.slice";

function* fetchSupportedCurrenciesSaga(): Generator<any> {
  const operationPath = ["cash", "provider", "currency", "list"];

  yield put(startLoading(operationPath));

  try {
    const data = yield callApi(CashProvidersApi.getSupportedCurrencies);

    yield put(setSupportedCurrencies({ data }));
    yield put(setSuccess(operationPath));
  } catch (error) {
    console.error(error);
    yield put(
      setError({
        path: operationPath,
        error,
      })
    );
  }
}

function* watchFetchSupportedCurrencies() {
  yield takeEvery(fetchSupportedCurrencies.type, fetchSupportedCurrenciesSaga);
}

export function* rootSaga() {
  yield fork(watchFetchSupportedCurrencies);
}
